/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function isDecString(val) {
    return typeof val === 'string' && /^[0-9]+$/.test(val);
}
export function isHexString(val) {
    return typeof val === 'string' && /^0x[0-9a-f]+$/i.test(val);
}
export function isHexBytes(val, n) {
    if (typeof val !== 'string' || !/^0x[0-9a-f]*$/i.test(val)) {
        return false;
    }
    return n ? val.length === n * 2 + 2 : val.length % 2 === 0;
}
export function isUInt(val, bit) {
    if (val < 0 || !Number.isInteger(val)) {
        return false;
    }
    return bit ? val < Math.pow(2, bit) : true;
}
export function isBigInt(v) {
    return typeof v === 'string' ?
        (isDecString(v) || isHexString(v)) :
        isUInt(v, 0);
}
export class BadParameter extends Error {
    constructor(msg) {
        super(msg);
    }
}
BadParameter.prototype.name = 'BadParameter';
export function ensure(b, msg) {
    if (!b) {
        throw new BadParameter(msg);
    }
}
import * as V from 'validator-ts';
export function test(value, scheme, context) {
    try {
        return V.validate(value, scheme, context);
    }
    catch (err) {
        if (err instanceof V.ValidationError) {
            throw new BadParameter(err.message);
        }
        throw err;
    }
}
// rules
export function bytes(v) {
    return isHexBytes(v) ? '' : 'expected bytes in hex string';
}
export function bytes8(v) {
    return isHexBytes(v, 8) ? '' : 'expected bytes8';
}
export function bytes32(v) {
    return isHexBytes(v, 32) ? '' : 'expected bytes32';
}
export function uint8(v) {
    return isUInt(v, 8) ? '' : 'expected 8-bit unsigned integer';
}
export function uint32(v) {
    return isUInt(v, 32) ? '' : 'expected 32-bit unsigned integer';
}
export function uint64(v) {
    return isUInt(v, 64) ? '' : 'expected 64-bit unsigned integer';
}
export function bool(v) {
    return typeof v === 'boolean' ? '' : 'expected boolean';
}
export function bigInt(v) {
    return isBigInt(v) ? '' : 'expected unsigned integer in number or string';
}
export function hexString(v) {
    return isHexString(v) ? '' : 'expected integer in hex string';
}
export function address(v) {
    return isHexBytes(v, 20) ? '' : 'expected address';
}
export function string(v) {
    return typeof v === 'string' ? '' : 'expected string';
}
//# sourceMappingURL=data:application/json;base64,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